(function () {
    'use strict';

    if (typeof window === 'undefined') {
        channels(
            module.exports,
            require('../../../public/enums/metrics.js'),
            require('../../../public/modules/data/channels.js'),
            require('lodash')
        );
    } else {
        channels(
            RivalIQ.module('props'),
            RivalIQ.enums,
            RivalIQ.data.channels,
            window._
        );
    }

    function channels(module, enums, channels, _) {

        const minMask = enums.sourceMask.TWITTER;
        function getMask(props, val) {
            if (_.isUndefined(val)) {
                val = props.channel;
            }

            if (minMask <= val) {
                return val;
            }

            const channel = channels.get(val);
            // NOTE handle deprecated channels
            return (channel ? channel.get('sourceMask') : 0);
        }

        /*
         * Returns true if this channel has been redacted due to missing token
         * permissions
         */
        module.channelRedacted = function (props, channel) {
            const sourceMask = getMask(props, channel);
            return Boolean(props.redactedSources & sourceMask);
        };

        /*
         * Returns true if this channel has been hidden by the user
         */
        module.channelHidden = function (props, channel) {
            const sourceMask = getMask(props, channel);
            return !(props.activeSources & sourceMask);
        };

        /*
         * Returns true if this channel is available on the current plan
         */
        module.channelSupported = function (props, channel) {
            const sourceMask = getMask(props, channel);
            return Boolean(props.supported_sources & sourceMask);
        };

        /*
         * Returns true if the channel is displayable (ignores missing tokens)
         */
        module.channelDisplay = function (props, channel) {
            const sourceMask = getMask(props, channel);
            const mask = props.supported_sources & props.activeSources;
            return Boolean(mask & sourceMask);
        };

        /*
         * Returns true if the channel is displayable (ignores missing tokens), or should be shown for upsell
         */
        module.channelDisplayWithUpsell = function (props, channel) {
            const sourceMask = getMask(props, channel);
            // NOTE assumption here is that every source is either a) in every plan OR b) has an upsell path
            const mask = props.activeSources;
            return Boolean(mask & sourceMask);
        };

        /*
         * Returns true if data should be displayed for this channel
         */
        module.channelAccess = function (props, channel) {
            const sourceMask = getMask(props, channel);
            return Boolean(module.sourceAccessMask(props) & sourceMask);
        };

        /*
         * Returns a source mask for sources that the user has access to
         * This means - Not hidden and available on this plan. This does not redact sources for which there is no token.
         */
        module.sourceAccessMask = function (props) {
            return props.supported_sources & props.activeSources;
        };

        module.getChannel = function (props) {
            return channels.get(props.channel);
        };

        // TODO use props activeSources instead of global state
        module.getChannels = function () {
            return channels.notHidden().withAccess().inCrossChannel();
        };

        return module;
    }
})();
